import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './reusable/Accordion'

function PayrollFilesInstructions () {
  return (
    <Accordion type='single' collapsible>
      <AccordionItem value='item-1'>
        <AccordionTrigger>
          <div className='text-thatch-purple-secondary'>
            Payroll files overview
          </div>
        </AccordionTrigger>
        <AccordionContent>
          <div className='page-section'>
            <p>
              Thatch provides a payroll deduction file at the end of each month. These files list the total monthly deductions for each employee, derived from each
              employee&apos;s over-budget spend or their contribution toward plan premiums and medical expenses.
            </p>
          </div>
        </AccordionContent>
      </AccordionItem>
      <AccordionItem value='item-2'>
        <AccordionTrigger>
          <div className='text-thatch-purple-secondary'>
            Initial setup instructions (one time only)
          </div>
        </AccordionTrigger>
        <AccordionContent>
          <div>
            <p className='text-sm -mt-2 mb-4'>
              Before you can enter the payroll deduction amounts for each period, ensure that your benefit types have been set up.
            </p>
            <div className='border rounded-lg bg-white'>
              <table className='table-auto w-full divide-y divide-gray-300 '>
                <thead className='bg-smoke'>
                  <tr className='divide-x'>
                    <th className='whitespace-nowrap pl-6 py-3 font-normal text-sm text-slate-700 text-left'>
                      Benefit Type
                    </th>
                    <th className='whitespace-nowrap pl-6 py-3 font-normal text-sm text-slate-700 text-left'>
                      Suggested Name
                    </th>
                    <th className='whitespace-nowrap pl-6 py-3 font-normal text-sm text-slate-700 text-left'>
                      Description
                    </th>
                  </tr>
                </thead>
                <tbody className='divide-y divide-gray-200 bg-white'>
                  <tr className='divide-x'>
                    <td className='whitespace-wrap px-6 py-3 text-sm text-left align-top'>
                      Section 125 Medical, or Health Insurance Managed by Third Party
                    </td>
                    <td className='whitespace-wrap px-6 py-3 text-sm text-left align-top'>
                      Pre-tax Medical Premium (Section 125) Deduction
                    </td>
                    <td className='whitespace-wrap px-6 py-3 text-sm text-left align-top'>
                      <p className='mb-2'>This is a pre-tax benefit for health insurance premiums. Sometimes this is found under a general “Health Insurance” section.</p>
                      <p>Overage amounts for off-exchange health insurance plans are pre-tax.</p>
                    </td>
                  </tr>
                  <tr className='divide-x'>
                    <td className='whitespace-wrap px-6 py-3 text-sm text-left align-top'>
                      Custom Post Tax, or Fringe Benefit
                    </td>
                    <td className='whitespace-wrap px-6 py-3 text-sm text-left align-top'>
                      Post-tax Deduction
                    </td>
                    <td className='whitespace-wrap px-6 py-3 text-sm text-left align-top'>
                      Any overages for on-exchange plans or unqualified medical spend will show up as post-tax deductions.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </AccordionContent>
      </AccordionItem>
      <AccordionItem value='item-3'>
        <AccordionTrigger>
          <div className='text-thatch-purple-secondary'>
            Entering deductions each month
          </div>
        </AccordionTrigger>
        <AccordionContent>
          <div className='page-section'>
            <div className='mb-4'>
              <h2 className='h2 mb-2' />
              <h3 className='text-sm font-semibold text-gray-900'>Step 1. Download the Payroll File</h3>
              <p className='text-sm'>
                Download your most recent payroll file from the table below. There will be a row for each employee and a column for each benefit type as outlined above.
              </p>
            </div>
            <div className='mb-4'>
              <h3 className='text-sm font-semibold text-gray-900'>Step 2. Set the deductions</h3>
              <p className='text-sm mb-2'>
                Each payroll file contains the deductions for the whole month. These deductions can be applied in a flexible manner. Your company payroll specialists can deduct the amounts once-a-month from a single paycheck, or distribute it across multiple paychecks to deduct smaller portions over time. The specific deductions can be applied pre-tax or post-tax, depending on the listed deduction type.
                That&apos;s it! If you have any questions please reach out to <a href='mailto:payroll@thatch.com'>payroll@thatch.com</a>. We&apos;re here to help!
              </p>
            </div>
          </div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  )
}

export default PayrollFilesInstructions
